import { getContext } from 'svelte';
const useActiveCategory = () => getContext('active-category');
export default useActiveCategory;
